import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { SponsorLogoUpload } from "@/components/sponsorship/SponsorLogoUpload";

export default function SponsorshipSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking" });

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/sponsorship/checkout-status/${sessionId}`);
        if (data.status === "paid" || data.status === "expired") { setState(data); return; }
        if (tries >= 8) { setState({ ...data, status: "unconfirmed" }); return; }
      } catch { setState({ status: "error" }); return; }
      tries += 1;
      timer = setTimeout(poll, 2000);
    };
    if (sessionId) poll(); else setState({ status: "error" });
    return () => clearTimeout(timer);
  }, [sessionId]);

  const paid = state.status === "paid";
  const pending = state.status === "checking" || state.status === "initiated";
  return (
    <PublicLayout>
      <section className="bg-[#F1F3F6] min-h-[60vh] py-20">
        <div className="max-w-xl mx-auto px-6 bg-white border border-slate-200 rounded-sm p-10 text-center" data-testid="sponsorship-success">
          {pending ? <Loader2 className="w-10 h-10 mx-auto animate-spin text-slate-400" />
            : paid ? <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-600" /> : <XCircle className="w-12 h-12 mx-auto text-[#E63946]" />}
          <h1 data-testid="sponsorship-success-title" className="font-display text-3xl uppercase tracking-tight mt-4 text-[#0A192F]">
            {pending ? "Confirming payment…" : paid ? "Welcome to the CBR team!" : state.status === "unconfirmed" ? "Payment still processing" : "Payment not completed"}
          </h1>
          <p className="text-sm text-slate-600 mt-3">
            {paid ? `Thank you${state.company ? `, ${state.company}` : ""}! Your ${state.package_name || ""} sponsorship is confirmed. Upload your logo below to go live now. We also emailed you this link.`
              : pending ? "This only takes a moment."
              : state.status === "unconfirmed" ? "We couldn't confirm your payment yet. If you completed checkout, you'll get a confirmation email shortly — otherwise no charge was made."
              : "No charge was made. You can try again or send us an enquiry."}
          </p>
          {paid && state.logo_token && <SponsorLogoUpload token={state.logo_token} />}
          <Link to={paid ? "/sponsors" : "/sponsorship"} data-testid="sponsorship-success-cta"
            className="inline-block mt-6 bg-[#0A192F] text-white px-6 py-3 text-xs font-semibold uppercase tracking-wider rounded-sm">
            {paid ? "See Our Sponsors" : "Back to Sponsorship"}
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
